module.exports = __webpack_public_path__ + "static/media/life-faq-banner-graphic.7ae68f68.png";